var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXFermerModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.262 33.6l27.667-27.667c0.624-0.624 0.624-1.638 0-2.262s-1.638-0.624-2.262 0l-27.667 27.667-27.667-27.667c-0.624-0.624-1.638-0.624-2.262 0s-0.624 1.638 0 2.262l27.667 27.667-27.667 27.667c-0.624 0.624-0.624 1.638 0 2.262 0.314 0.314 0.723 0.467 1.133 0.467s0.819-0.157 1.133-0.467l27.667-27.667 27.667 27.667c0.314 0.314 0.723 0.467 1.133 0.467s0.819-0.157 1.133-0.467c0.624-0.624 0.624-1.638 0-2.262l-27.674-27.667z",
    fill: "#095797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXFermerModal);
export default __webpack_public_path__ + "static/media/x-fermer-modal.402e3e73ee573fbdf7b7d2b91af25e3b.svg";
export { ForwardRef as ReactComponent };